import FormSection from '@/components/Forms/FormSection';
import { Box } from '@palmetto/palmetto-components';
import { Link } from 'react-router-dom';

import {
  HVACInstallPackageFileCategory,
  InstallationPackagePhotoCategory,
  ProgramType,
  RequirementFlagSettingsType,
} from 'types';

import { PhotosList } from '../Documents/PhotosList';

export const SystemPhotos = ({
  showCheckboxes,
  checkboxCategories,
  isPackageEditable = true,
}: {
  showCheckboxes: boolean;
  checkboxCategories: HVACInstallPackageFileCategory[];
  isPackageEditable?: boolean;
}) => {
  return (
    <>
      <FormSection
        title="New System Photos"
        description={
          <>
            <Box>Upload photos to all applicable categories.</Box>
            <Box>
              Reference <Link to={''}>Install Photo Requirements documentation</Link> for specifics on submission
              requirements.
            </Box>
          </>
        }
      >
        <PhotosList
          title="Project Site"
          description="House Number: Provide photo of the house number to verify location of Installation"
          category={InstallationPackagePhotoCategory.projectSite}
          baseCategory="Installation Photo Documentation"
          flagType={RequirementFlagSettingsType.projectSiteHVAC}
          showCheckboxes={showCheckboxes}
          checkboxCategories={checkboxCategories}
          programType={ProgramType.hvac}
          showIfEmpty={false}
          isPackageEditable={isPackageEditable}
        />
        <PhotosList
          title="Indoor System"
          description="Provide a photo of the data tag of each piece of indoor equipment. Data tag photos should clearly show model and serial number. Indoor equipment typically consists of an Air Handler, Furnace and Coil combination, or a combination of ducted and non-ducted mini split units."
          category={InstallationPackagePhotoCategory.indoorSystem}
          baseCategory="Installation Photo Documentation"
          flagType={RequirementFlagSettingsType.indoorSystem}
          showCheckboxes={showCheckboxes}
          checkboxCategories={checkboxCategories}
          programType={ProgramType.hvac}
          isPackageEditable={isPackageEditable}
        />
        <PhotosList
          title="Outdoor System"
          description="Provide a photo of the data tag of each piece of outdoor equipment. Data tag photos should clearly show model and serial number. Outdoor equipment typically consists of an Air Conditioner, Heat Pump Condenser, or Packaged Unit."
          category={InstallationPackagePhotoCategory.outdoorSystem}
          baseCategory="Installation Photo Documentation"
          flagType={RequirementFlagSettingsType.outdoorSystem}
          showCheckboxes={showCheckboxes}
          checkboxCategories={checkboxCategories}
          programType={ProgramType.hvac}
          isPackageEditable={isPackageEditable}
        />
        <PhotosList
          title="Zoning System"
          description="Zone Board, Zone Dampers, Zone Controls or Zone Sensors, Bypass Damper (if applicable)"
          category={InstallationPackagePhotoCategory.zoningSystem}
          baseCategory="Installation Photo Documentation"
          flagType={RequirementFlagSettingsType.zoningSystem}
          showCheckboxes={showCheckboxes}
          checkboxCategories={checkboxCategories}
          programType={ProgramType.hvac}
          showIfEmpty={false}
          isPackageEditable={isPackageEditable}
        />
        <PhotosList
          title="Thermostat"
          description="Thermostat photos are to show the thermostat powered on and operational."
          category={InstallationPackagePhotoCategory.thermostat}
          baseCategory="Installation Photo Documentation"
          flagType={RequirementFlagSettingsType.thermostat}
          showCheckboxes={showCheckboxes}
          checkboxCategories={checkboxCategories}
          programType={ProgramType.hvac}
          showIfEmpty={false}
          isPackageEditable={isPackageEditable}
        />
        <PhotosList
          title="Accessories"
          description="Picture of each accessory and data plate (if applicable), e.g. Humidifier, UV Light, Electronic Air Cleaner"
          category={InstallationPackagePhotoCategory.accessories}
          baseCategory="Installation Photo Documentation"
          flagType={RequirementFlagSettingsType.accessoriesHVAC}
          showCheckboxes={showCheckboxes}
          checkboxCategories={checkboxCategories}
          programType={ProgramType.hvac}
          showIfEmpty={false}
          isPackageEditable={isPackageEditable}
        />
      </FormSection>
    </>
  );
};
